/**
 * Wave 10 zod-mandate — runtime schemas for the conflict-policy public
 * exports.
 *
 * @example
 * ```ts
 * import { ResolveConflictPolicySpecSchema } from './ConflictPolicy.schema'
 * ResolveConflictPolicySpecSchema.parse('lww')
 * ```
 */
import { z } from 'zod'
import { ConflictPolicyNameSchema } from './SyncQueueConfig.schema'

// Accepts: a name (one of four canonical strings), a function, or undefined
// (defaults to server-authoritative). The function form is checked via the
// custom predicate so a non-string/non-function input genuinely fails.
export const ResolveConflictPolicySpecSchema = z
	.union([
		ConflictPolicyNameSchema,
		z.custom<(...args: unknown[]) => unknown>((v) => typeof v === 'function'),
		z.undefined(),
	])

export const SyncConflictSchema = z
	.object({
		entry: z.unknown(),
		serverRow: z.unknown(),
		serverVersion: z.number().nullable(),
		message: z.string().nullable(),
		detected_at: z.number(),
		// 0.4.0 — the host's optimistic placeholder key, mirroring
		// `SyncConfirmation.tempId`, present only when the enqueue supplied one.
		tempId: z.string().min(1).optional(),
	})
	.passthrough()

export type SyncConflictInput = z.infer<typeof SyncConflictSchema>
